import { FC, MouseEventHandler } from "react";
import ArrowIcon from "assets/icons/loyalty/arrow.svg?react";
import classnames from "classnames";
import useTranslate from "hooks/useTranslate";
import "./styles.sass";

type StoryButtonProps = {
  label: string;
  handleClick?: () => void;
  className?: string;
};

const StoryButton: FC<StoryButtonProps> = ({
  label,
  handleClick,
  className,
}) => {
  const t = useTranslate();
  const buttonClassname = classnames("StoryButton", className);

  const handleLocalClick: MouseEventHandler = (event) => {
    event.stopPropagation();
    handleClick?.();
  };

  return (
    <button
      type="button"
      onClick={handleLocalClick}
      className={buttonClassname}
    >
      {t(label)}
      <ArrowIcon className="StoryButton__icon" />
    </button>
  );
};

export default StoryButton;
